<div class="login-dialog alt-justify-center">
  <h2>{{"AUTH.login" | translate}} {{statusDetail}}</h2>
  <p *ngIf="statusDetail =='error'">{{"AUTH.invalid-acces" | translate}}</p>
  <p *ngIf="statusDetail =='success'">{{"AUTH.valid-acces" | translate}}</p>
</div>
